import { makeRequest } from "@/services/index";

export async function getSolicitations() {
  return await makeRequest("GET", "solicitacions");
}

export async function getSolicitationsWithFilters(filters) {
  return await makeRequest("GET", "solicitacions", null, filters);
}

export async function getSolicitationDetails(solicitationId) {
  return await makeRequest("GET", `solicitacions/${solicitationId}`);
}

export async function getStatusSolicitation() {
  return await makeRequest("GET", "solicitacion_status");
}

export async function storeSolicitation(solicitation) {
  return await makeRequest("POST", "solicitacions", solicitation);
}

export async function updateSolicitation(id, data) {
  return await makeRequest("PUT", `solicitacions/${id}`, data);
}

export async function cancelSolicitation(data) {
  return await makeRequest("POST", "canceled_solicitations", data);
}

export async function changeStatusSolicitation(id, data) {
  return await makeRequest("PATCH", `solicitacions/changeStatus/${id}`, data);
}

export async function addObservationInSolicitation(id, data) {
  return await makeRequest("POST", `solicitacions/addObs/${id}`, data);
}

export async function addAttachment(solicitacionsId, data) {
  return await makeRequest(
    "POST",
    `solicitacions/saveFiles/${solicitacionsId}`,
    data
  );
}

export async function downloadFile(fileId, solicitacionsId) {
  return await makeRequest(
    "GET",
    `solicitacions/downloadFile/${fileId}`,
    null,
    { solicitation_id: solicitacionsId },
    "arraybuffer"
  );
}

export async function removeFile(fileId) {
  return await makeRequest("DELETE", `solicitacions/inactivateFile/${fileId}`);
}

export async function getAssessmentByFilters(data) {
  return await makeRequest("GET", "assessments", null, data);
}

export async function changeAssessmentStatus(solicitationId, data) {
  return await makeRequest(
    "PATCH",
    `assessments/changeStatus/${solicitationId}`,
    null,
    data
  );
}

export async function getPatientStatus() {
  return await makeRequest("GET", "patient_status");
}

export async function getTransportType() {
  return await makeRequest("GET", "transport_types");
}

export async function getPriorityClassification() {
  return await makeRequest("GET", "risks");
}

export async function getRegulateReasons() {
  return await makeRequest("GET", "reasons");
}

export async function closeSolicitationSchedule(data) {
  return await makeRequest("POST", "reason_closures", data);
}

export async function getPatientInLU(patient) {
  return await makeRequest("GET", "single_patient_lists", null, patient);
}

export async function updatePatientInLUStatus(idLU) {
  return await makeRequest("PATCH", `single_patient_lists/${idLU}`, null, {
    used: "1", // 0 false, 1 = true
  });
}

export async function rejectSolicitation(solicitationId, unities) {
  return await makeRequest(
    "POST",
    `/solicitacions/rejectSolicitation/${solicitationId}`,
    null,
    {
      unities: unities,
    }
  );
}

export async function removeBindedUnityOnSolicitation(solicitationId) {
  return await makeRequest(
    "PATCH",
    `solicitacions/updateSingleColumnBindedUnityId/${solicitationId}`
  );
}

export async function removeReferenceSolicitation(solicitationId, data) {
  return await makeRequest(
    "POST",
    `solicitacions/removeReferenceSolicitation/${solicitationId}`,
    data
  );
}

export async function includeCIDInSolicitation(solicitationId, data) {
  return await makeRequest(
    "PATCH",
    `solicitacions/cid/${solicitationId}`,
    data
  );
}
